import React from "react";
import { Link } from "react-router-dom";
import styles from "./Home.module.css";
import VisitCounter from "../Components/VisitCounter";
const Home = () => {
  return (
    <div name="Inicio" className={styles.home}>
      {/* <div className={styles.visitCounter}>
        <VisitCounter />
        </div> */}
      <div className={styles.titleContainer1}>
        <p>
          Damos forma a tus ideas con
          <br />
          <b>experiencias digitales.</b>
        </p>
      </div>
      <div className={styles.titleContainer2}>
        <p>
          Hagamos
          <br />
          <b>algo increíble.</b>
        </p>
      </div>
      
      <div className={styles.actionContainer}>
        <Link
          to="/contacto"
          smooth
          duration={500}
          className={styles.callToAction1}
        >
          Cuéntanos tu idea
        </Link>
        {/* <Link
          to="/contacto"
          smooth
          duration={500}
          className={styles.callToAction2}
        >
          Pídenos presupuesto
        </Link> */}
      </div>
      
    </div>
  );
};

export default Home;
